// Imports MUI Components
import { Typography } from "@mui/material"

const Text = ({ text, variant }) => {
  return (
    <div>
      {/* Text */}
      <Typography
        variant={variant}
        >{text}
      </Typography>
    </div>
  );
};

export default Text;